import { useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

// Session cache — fetched once per page load.
let cache = null;
export const clearPlatformCache = () => { cache = null; };

/**
 * Public platform settings consumed by the student app: feature flags,
 * maintenance mode and branding. Defaults to "everything enabled" until the
 * fetch resolves so nothing flashes hidden.
 */
export const usePlatform = () => {
  const [settings, setSettings] = useState(cache);

  useEffect(() => {
    if (cache) { setSettings(cache); return; }
    let active = true;
    fetch(`${API}/api/settings/public`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (d) { cache = d; if (active) setSettings(d); } })
      .catch(() => { /* keep defaults */ });
    return () => { active = false; };
  }, []);

  const feature = (key) => !settings || settings.features?.[key] !== false;
  return {
    settings,
    loaded: !!settings,
    feature,
    maintenance: !!settings?.maintenance_mode,
    maintenanceMessage: settings?.maintenance_message || '',
    productName: settings?.product_name || 'Founder OS',
  };
};

export default usePlatform;
